// axiosInstance.js
import axios from 'axios';

// Create a custom Axios instance for /oapi proxy calls (server-side handling of credentials)
const oapiAxios = axios.create({
  baseURL: '/oapi',  // Proxy through local server for security
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

oapiAxios.defaults.withCredentials = false;

// Remove global Authorization header for OrderWise API calls to prevent Bearer token interference
oapiAxios.defaults.headers.common['Authorization'] = undefined;

// Add PIM JWT token via X-PIM-JWT header for authentication with the proxy server
// This allows the server to verify the user while still passing OrderWise Bearer tokens in Authorization
oapiAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['X-PIM-JWT'] = token;
  }
  return config;
});

export default oapiAxios;
